import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../lib/auth.js';

interface AdminOnlyProps {
  children: ReactNode;
}

/**
 * Client-side route gate for admin-only paths. Redirects to / when the
 * current admin's role is not 'admin'. Returns null while unauthenticated
 * (parent route tree handles login redirection).
 *
 * NOTE: server-side role enforcement is the security boundary
 * (T-008 requireRole middleware). This wrapper is purely a UX nicety.
 */
export function AdminOnly({ children }: AdminOnlyProps) {
  const { admin } = useAuth();
  if (!admin) return null;
  if (admin.role !== 'admin') return <Navigate to="/" replace />;
  return <>{children}</>;
}
